function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-aircon_svg__a",
  d: "M0 0h100v100H0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "icon-aircon_svg__b"
}, React.createElement("use", {
  xlinkHref: "#icon-aircon_svg__a",
  overflow: "visible"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M54.4 65.81V12.83C54.4 8.51 50.91 5 46.6 5s-7.8 3.5-7.8 7.82v52.99c-4.66 2.7-7.8 7.75-7.8 13.53C31 88 37.99 95 46.6 95c8.62 0 15.6-7 15.6-15.65 0-5.79-3.14-10.83-7.8-13.54h0zm-7.8 17.45c2.15 0 3.9-1.75 3.9-3.91s-1.75-3.91-3.9-3.91-3.9 1.75-3.9 3.91 1.75 3.91 3.9 3.91h0zm0-7.82V36.3v39.14h0zm15.6-19.57H70h-7.8 0zm0-19.57H70h-7.8 0zm0-19.56H70h-7.8 0z",
  clipPath: "url(#icon-aircon_svg__b)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

function SvgIconAircon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuNiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+CgkKCQkuc3Qwe2NsaXAtcGF0aDp1cmwoI1NWR0lEXzJfKTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGc+Cgk8Zz4KCQk8ZGVmcz4KCQkJPHJlY3QgaWQ9IlNWR0lEXzFfIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIvPgoJCTwvZGVmcz4KCQk8Y2xpcFBhdGggaWQ9IlNWR0lEXzJfIj4KCQkJPHVzZSB4bGluazpocmVmPSIjU1ZHSURfMV8iICBzdHlsZT0ib3ZlcmZsb3c6dmlzaWJsZTsiLz4KCQk8L2NsaXBQYXRoPgoJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik01NC40LDY1LjgxVjEyLjgzQzU0LjQsOC41MSw1MC45MSw1LDQ2LjYsNXMtNy44LDMuNS03LjgsNy44MnY1Mi45OWMtNC42NiwyLjctNy44LDcuNzUtNy44LDEzLjUzCgkJCUMzMSw4OCwzNy45OSw5NSw0Ni42LDk1YzguNjIsMCwxNS42LTcsMTUuNi0xNS42NUM2Mi4yLDczLjU2LDU5LjA2LDY4LjUyLDU0LjQsNjUuODFMNTQuNCw2NS44MXogTTQ2LjYsODMuMjYKCQkJYzIuMTUsMCwzLjktMS43NSwzLjktMy45MXMtMS43NS0zLjkxLTMuOS0zLjkxYy0yLjE1LDAtMy45LDEuNzUtMy45LDMuOTFTNDQuNDUsODMuMjYsNDYuNiw4My4yNkw0Ni42LDgzLjI2eiBNNDYuNiw3NS40NFYzNi4zCgkJCVY3NS40NEw0Ni42LDc1LjQ0eiBNNjIuMiw1NS44N0g3MEg2Mi4yTDYyLjIsNTUuODd6IE02Mi4yLDM2LjNINzBINjIuMkw2Mi4yLDM2LjN6IE02Mi4yLDE2Ljc0SDcwSDYyLjJMNjIuMiwxNi43NHoiLz4KCTwvZz4KPC9nPgo8L3N2Zz4K";
export { SvgIconAircon as ReactComponent };